import { render } from "./InputCateg.vue?vue&type=template&id=f25a598c&scoped=true"
import script from "./InputCateg.vue?vue&type=script&lang=js"
export * from "./InputCateg.vue?vue&type=script&lang=js"

import "./InputCateg.vue?vue&type=style&index=0&id=f25a598c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f25a598c"]])

export default __exports__